import {
  Card,
  CardContainer,
  Container,
  Heading,
  CardDescription,
  CardTitle,
  Icon
} from './Features.style';
import FastSetupIcon from '../../../assets/images/FastSetup.webp';
import NonCustodialIcon from '../../../assets/images/NonCustodial.webp';
import ExtensiveSupportIcon from '../../../assets/images/ExtensiveSupport.webp';
import NoChargebacksIcon from '../../../assets/images/NoChargebacks.webp';
import GlobalIcon from '../../../assets/images/Global.webp';
import HostedCheckoutPageIcon from '../../../assets/images/HostedCheckoutPage.webp';
import CustomIntegrationIcon from '../../../assets/images/CustomIntegration.webp';
import InvoicingIcon from '../../../assets/images/Invoicing.webp';
import AnalyticsIcon from '../../../assets/images/Analytics.webp';

export const FeaturesSection = () => {
  return (
    <Container>
      <Heading>Features you’ll love</Heading>
      <CardContainer>
        <Card>
          <Icon src={FastSetupIcon} />
          <CardTitle>Instant Setup</CardTitle>
          <CardDescription>
            Start accepting payments from anyone within minutes
          </CardDescription>
        </Card>
        <Card>
          <Icon src={NonCustodialIcon} />
          <CardTitle>Non-Custodial</CardTitle>
          <CardDescription>
            Instant settlements of all payments and funds delivered instantly to
            your wallet
          </CardDescription>
        </Card>
        <Card>
          <Icon src={ExtensiveSupportIcon} />
          <CardTitle>Extensive Support</CardTitle>
          <CardDescription>
            Accept payments in 8+ networks in 50+ popular cryptocurrencies
            including all major stablecoins
          </CardDescription>
        </Card>
        <Card>
          <Icon src={NoChargebacksIcon} />
          <CardTitle>No Chargebacks</CardTitle>
          <CardDescription>
            No need to worry about chargebacks anymore
          </CardDescription>
        </Card>
        <Card>
          <Icon src={GlobalIcon} />
          <CardTitle>Global Reach</CardTitle>
          <CardDescription>
            Send and receive payments from anyone in the world instantly
          </CardDescription>
        </Card>
        <Card>
          <Icon src={HostedCheckoutPageIcon} />
          <CardTitle>Hosted Checkout Page</CardTitle>
          <CardDescription>
            Get started with our hosted checkout page
          </CardDescription>
        </Card>
        <Card>
          <Icon src={CustomIntegrationIcon} />
          <CardTitle>Custom Integration</CardTitle>
          <CardDescription>
            Build custom integration for crypto payment to provide seamless UX
            to the user
          </CardDescription>
        </Card>
        <Card>
          <Icon src={InvoicingIcon} />
          <CardTitle>Invoicing</CardTitle>
          <CardDescription>
            Create and manage all invoices from an easy-to-use dashboard
          </CardDescription>
        </Card>
        <Card>
          <Icon src={AnalyticsIcon} />
          <CardTitle>Donation</CardTitle>
          <CardDescription>
            Enables charities/content creators to accept donations in crypto on
            fast and low-fees networks
          </CardDescription>
        </Card>
      </CardContainer>
    </Container>
  );
};
